export const OFFICE_ADDRESS = {
  corporate:
    "Zakir Complex (9th Floor), Ka-218, Kuril Chowrasta, Dhaka-1229, Bangladesh.",
  pickup:
    "Siraj Garden, Ka-193/B, Sayed Ali Member Bari, Kuril Chowrasta, Dhaka-1229, Bangladesh.",
  pickup_map:
    "https://www.google.com/maps/place/AmarPet/@23.8160575,90.4225,17z/data=!3m1!4b1!4m6!3m5!1s0x3755c7645f4d2aeb:0xf870e7ed1e780d80!8m2!3d23.8160575!4d90.4225!16s%2Fg%2F11twhw_6b0?entry=ttu",
};
